<template>
<div id="banner">
  <div class="container">
    <el-drawer class="side-menu" :visible.sync="drawer" :append-to-body="true" :direction="direction" size="50%">
      <ul @click="findCategroy" style="border-bottom: 1px solid rgba(114,118,131,0.5);">
        <li v-if="!hideCourseTab">选课中心</li>
        <li>讲座</li>
      </ul>
      <ul>
        <li>
          <a :href="webHref">质心{{JIANGSAI}}</a>
        </li>
        <li>
          <a :href="getMobileUrl">手机客户端</a>
        </li>
      </ul>
    </el-drawer>
    <div class="banner-contaier">
      <div class="phone-logo">
        <div class="icon" @click="drawer = true">
          <img src="@/assets/img/icon/nav.png" alt="logo" />
        </div>
      </div>
      <div class="phone-nav">
        <div v-if="isPhone" class="phone_pagetext">
            {{navText}}
        </div>
        <div class="logout" v-if="isLogin">
            <router-link tag="div" class="my_class" :to="{ name: 'MyCourse'}">我的课程</router-link>
            <div
            class="phone-number flex-center float-right hidden-xs"
            >{{userInfo.mobile&&userInfo.mobile.toString().substring(0,3)+'****'+userInfo.mobile.toString().substring(7,11)}}</div>
            <el-dropdown @command="handleCommand" @visible-change="visibleChange" trigger="click">
            <div class="user-info">
                <div class="userimg">
                <img src="../../assets/img/crown@2x.png" alt="" class="crown" v-if="userInfo.is_vip_plus">
                <img :src="userInfo.avatar" alt="" >
                </div>
                <div class="icon_down" :style="down_list?'transform: rotate(180deg);transition: 0.4s;':'transition: 0.4s;'">
                <i class="fa fa-xiala"></i>
                </div>
            </div>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="vip" v-if="userInfo.is_vip_plus">我的会员</el-dropdown-item>
                <el-dropdown-item :divided="userInfo.is_vip_plus" command="order">我的订单</el-dropdown-item>
                <el-dropdown-item divided command="coupon">我的礼券</el-dropdown-item>
                <el-dropdown-item divided command="protons">质子管理</el-dropdown-item>
                <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div class="login" v-if="!isLogin">
            <el-button type="primary" @click="goLogin">登录</el-button>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import banner from './banner'

export default {
  mixins: [banner],
  data () {
    return {
      hideCourseTab: Number(process.env.VUE_APP_HIDE_COURSE_TAB) === 1
    }
  }
}
</script>

<style  lang="scss" scoped>
@import "@/assets/scss/_base.scss";

.flex-center {
  display: flex;
  justify-items: center;
  align-items: center;
}
.hand {
  cursor: pointer;
}
#banner {
  background: $pagination-bg;
  border-radius: 2px;
  align-items: center;
  border-bottom: 1px solid rgba($base-color, 0.1);
  height: 75px;
  position: relative;
  z-index: 9999;
  .container {
    height: 100%;
  }
  .banner-contaier {
    display: flex;
    align-items: center;
    height: 100%;
    .logo {
      display: flex;
      width: 10%;
      cursor: pointer;
      .icon {
        width: 92px;
        height: 25px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .tab-type {
      width: 50%;
      justify-content: left;
      position: absolute;
      top: 35px;
      .el-tabs__header {
        margin: 0;
      }
      :after {
        display: none;
      }
    }
    .logout {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: unset;
      height: unset;
      position: relative;
      .down_list{
        position: absolute;
        width: 132px;
        height: 109px;
        box-sizing: border-box;
        background: $pagination-bg;
        box-shadow:0px 4px 16px 0px rgba(172,183,195,0.15);
        border-radius:4px;
        border:1px solid rgba($base-color,0.06);
        top: 48px;
        right: -28px;
        @media screen and(max-width: 786px){
          right: 0;
        }
        div{
          height: 54px;
          width: 100px;
          text-align: center;
          margin: auto;
          line-height: 54px;
          font-size:.373333rem;
          font-weight:400;
        }
        div:nth-child(1){
          border-bottom: 1px solid rgba($base-color,0.08);
        }
        div:hover {
          color: $brand-success;
          cursor: pointer;
        }
      }
      .icon_down{
        font-size: .32rem;
        color: $gray-light;
      }
      .my_class{
        padding: 0px 16px;
        border-right: 1px solid $gray-lighter;
        margin-right: 16px;
        cursor: pointer;
        font-size: .373333rem;
      }
      .user-info{
        cursor: pointer;
        display: flex;
        align-items: center;
        height: 100%;
      }
      .userimg{
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin: 0px 9px 0px 16px;
        position: relative;
        img{
           width: 30px;
           height: 30px;
           border-radius: 50%;
        }
        .crown{
          width: 18px;
          height: 12px;
          position: absolute;
          top: -7px;
          left: 16px;
          transform:rotate(28deg);
          -webkit-transform:rotate(28deg);
          -moz-transform:rotate(28deg);
        }
      }
      .phone-number {
        font-size: .373333rem;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .logout-text {
        margin-left: 20px;
        font-size: .373333rem;
        font-weight: 400;
        color: $gray;
      }
      .logout-icon {
        width: 14px;
        height: 15px;
        margin-left: 5px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .login {
      width: 33%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      button {
          width: 48px;
          height: 24px;
          margin: 0;
          padding: 0;
      }
    }
    .phone-logo {
        .icon {
          position: relative;
          top: 2px;
            img {
                width: .373333rem;
            }
        }
    }
    .phone-nav{
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 1;
        margin-left: 11px;
        .phone_pagetext{
            font-size: .373333rem;
        }
    }
  }
}
  #zhixin-app
    > div#banner
    > div
    > div.tab-type.flex-center
    > div
    > div.el-tabs__header.is-top
    > div
    > div
    > div
    > div.el-tabs__active-bar {
    width: 16px !important;
    left: 19px !important;
  }

  .side-menu {
    ul li {
      display: flex;
      height: 52px;
      font-size: .426667rem;
      line-height: 52px;
      box-sizing: border-box;
      padding-left: 15px;
      color: rgba($base-color, 0.7);
      a {
        color: rgba($base-color, 0.7);
      }
    }
  }
</style>
